window.datalayerRender = (eventName, productData) => {
	if (!window.dataLayer) {
		window.dataLayer = [];
	}
	window.dataLayer.push({ ecommerce: null });
	window.dataLayer.push({
		event: eventName,
		ecommerce: {
			items: [productData]
		}
	});
};

document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
	const cartInfo = event.detail.smartcart;
	const item = event.detail.item;

	if (item) {
		window.datalayerRender("remove_from_cart", {
			item_id: item.sku,
			item_name: item.product_title,
			coupon: cartInfo.discount?.code || '',
			currency: window.BARREL?.currencyCode || 'USD',
			discount: (parseFloat(cartInfo.discount?.amount || 0) / 100).toFixed(2),
			index: 0,
			item_brand: item.vendor,
			item_category: '',
			item_list_id: "mini_cart",
			item_list_name: "Mini Cart",
			item_variant: item.variant_title,
			price: (parseFloat(item.price) / 100).toFixed(2),
			quantity: item.quantity
		});
	}
});

document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
	const cartInfo = event.detail.smartcart;
	const item = event.detail.item;
	const quantityNum = Math.max(parseFloat(item.quantity) - 1, 0);

	if (item) {
		window.datalayerRender("remove_from_cart", {
			item_id: item.sku,
			item_name: item.product_title,
			coupon: cartInfo.discount?.code || '',
			currency: window.BARREL?.currencyCode || 'USD',
			discount: (parseFloat(cartInfo.discount?.amount || 0) / 100).toFixed(2),
			index: 0,
			item_brand: item.vendor,
			item_category: '',
			item_list_id: "mini_cart",
			item_list_name: "Mini Cart",
			item_variant: item.variant_title,
			price: (parseFloat(item.price) / 100 * quantityNum).toFixed(2),
			quantity: quantityNum
		});
	}
});

document.addEventListener('rebuy:smartcart.show', (event) => {
	const smartcart = event.detail.smartcart;
	const cartItems = smartcart.cart?.items || smartcart.items || [];

	const items = cartItems.map((item, index) => ({
		item_id: item.sku || '',
		item_name: item.product_title || '',
		coupon: smartcart.discount?.code || '',
		currency: window.BARREL?.currencyCode || 'USD',
		discount: item.total_discount ? (parseFloat(item.total_discount) / 100).toFixed(2) : '',
		index: index,
		item_brand: item.vendor || '',
		item_category: '',
		item_list_id: 'mini_cart',
		item_list_name: 'Mini Cart',
		item_variant: item.variant_title || '',
		price: (parseFloat(item.final_price) / 100).toFixed(2),
		quantity: parseFloat(item.quantity) || 1
	}));

	window.datalayerRender("view_cart", items);
});

document.addEventListener('rebuy:smartcart.ready', (event) => {
  const root = document.documentElement;
  const body = document.body;

  if (!root || !body) return;

  const originalScrollPaddingTop = getComputedStyle(root).scrollPaddingTop;
  const originalScrollPaddingBlockStart = getComputedStyle(root).scrollPaddingBlockStart;

  let initialScrollY = 0;
  let restored = false;

  document.addEventListener("rebuy:smartcart.show", function () {
    restored = false;
    initialScrollY = window.scrollY;

    root.style.scrollPaddingTop = "0px";
    root.style.scrollPaddingBlockStart = "0px";
  });

  document.addEventListener("rebuy:smartcart.hide", function () {
    const handleScroll = () => {
      const scrollDifference = Math.abs(window.scrollY - initialScrollY);

      if (scrollDifference > 10 && !restored) {
        root.style.scrollPaddingTop = originalScrollPaddingTop;
        root.style.scrollPaddingBlockStart = originalScrollPaddingBlockStart;

        restored = true;
        window.removeEventListener("scroll", handleScroll);
      }
    };

    setTimeout(() => {
      window.addEventListener("scroll", handleScroll);
    }, 300);

    setTimeout(() => {
      if (!restored) {
        root.style.scrollPaddingTop = originalScrollPaddingTop;
        root.style.scrollPaddingBlockStart = originalScrollPaddingBlockStart;
      }
    }, 1000);
  });
});
